import { render, staticRenderFns } from "./travel-tool-skeleton.vue?vue&type=template&id=9488ceaa"
import script from "./travel-tool-skeleton.vue?vue&type=script&lang=ts&setup=true"
export * from "./travel-tool-skeleton.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports